/**
 * @description Permet de cibler les characters/mots souhaités pour leur appliquer une classe
 */

(() => {
	// VARS

	/**
	 * @param word mot ciblé
	 * @param classWord class a ajouter
	 */

	const styleDate = (word, classWord) => {
		const card = document.querySelectorAll('.hp-edito__events__item');
		card.forEach((item) => {
			const dateTag = item.querySelector('div:first-child');
			if (dateTag.innerHTML.indexOf(word) > -1) {
				dateTag.innerHTML = dateTag.innerHTML.replace(
					word,
					'<span class="' + classWord + '">' + word + '</span>'
				);
			}
		});
	};

	// GO 🚀
	const init = () => {
		styleDate('Du', 'event-date--regular');
		styleDate('au', 'event-date--regular');
		styleDate('Le', 'event-date--regular');
		styleDate('From', 'event-date--regular');
		styleDate('to', 'event-date--regular');
	};

	init();
})();
